import { Box, Card, Divider, Typography } from '@mui/material';
import { useUserDataTable } from '../hooks/useUserDataTable';
import { DownloadButton } from './DownloadButton';
import { FeedbackTableRow } from './FeedbackTableRow';
import { TableComponent } from './TableComponent';
const ExportableTable = ({
  npsData,
  noFeedback,
  failed,
  feedbackType,
  dateUploadCount,
  salesData,
  enquiryData,
}) => {
  const {
    exportDataForFailed,
    user,
    handleExport,
    tableData,
    handleDateWiseExport,
    page,
    handleChangePage,
    keys,
  } = useUserDataTable(
    npsData,
    noFeedback,
    failed,
    feedbackType,
    dateUploadCount,
    salesData,
    enquiryData
  );

  const renderTable = () => {
    const tableMap =
      user?.tableMap?.[feedbackType] ||
      user.oemMappings?.tableMap?.[feedbackType];
    return tableMap?.length > 0 ? (
      <TableComponent
        page={page}
        handleChangePage={handleChangePage}
        data={tableData}
      >
        {tableData.slice(page * 15, page * 15 + 15).map((item, index) => (
          <FeedbackTableRow
            key={index}
            allKeys={keys}
            index={index}
            item={item}
          />
        ))}
      </TableComponent>
    ) : (
      <Typography>Contact Admin to Configure Table Data</Typography>
    );
  };

  return (
    <div className="dark">
      <Card
        variant="outlined"
        sx={{
          boxShadow: 3,
          width: '100%',
          p: '15px',
          background: '#1d2637',
          color: 'white',
          fontFamily: 'Montserrat, serif !important',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="space-between"
          marginBottom={2}
          marginTop={2}
        >
          <Typography
            variant="overline"
            gutterBottom
            sx={{ color: 'white', fontFamily: 'Montserrat, serif !important' }}
          >
            NPS Data
          </Typography>
          {user?.lastUpload && (
            <Typography
              variant="overline"
              gutterBottom
              sx={{
                color: 'white',
                fontFamily: 'Montserrat, serif !important',
                textAlign: 'right',
              }}
            >
              Last Uploaded Date : {user?.lastUpload?.[feedbackType]}
            </Typography>
          )}
        </Box>

        <Divider />
        <Box
          display="flex"
          alignItems="center"
          alignSelf={'flex-end'}
          justifyContent="space-between"
          marginBottom={2}
          marginTop={2}
        >
          <DownloadButton onClick={handleExport} title={'Export NPS Data'} />
          {failed && failed?.length > 0 && (
            <DownloadButton
              onClick={exportDataForFailed}
              title={'Export Delivery Failed Data'}
            />
          )}
          <DownloadButton
            onClick={handleDateWiseExport}
            title={'Export Date Wise Upload Report'}
          />
        </Box>
        {renderTable()}
      </Card>
    </div>
  );
};

export default ExportableTable;
